import { GridColumnProps } from "@roc/ui";
import { PaymentApprovalFilter, TaxTabs } from "../types/types";
import { getPaymentApprovalColumns, TAX_CERT_COLUMNS, TAX_REDEMPTION_COLUMNS } from "./constants";

export const getTaxColumns = (tab: TaxTabs, paymentFilter: PaymentApprovalFilter): GridColumnProps[] => {
  switch (tab) {
    case TaxTabs.TAX_CERTIFICATE:
      return TAX_CERT_COLUMNS;
    case TaxTabs.REDEMPTION_REQUEST:
      return TAX_REDEMPTION_COLUMNS;
    case TaxTabs.PAYMENT_APPROVAL:
      return getPaymentApprovalColumns(paymentFilter);
    default:
      return TAX_CERT_COLUMNS;
  }
}
